<template>
  <div class="text-xs-center">
    <v-dialog
      :value="value"
      @input="$emit('input')"
      width="500"
    >
      <v-card>
        <v-card-title
          class="headline grey lighten-2 py-0"
          primary-title
        >
          Setar Previsão
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <v-btn
              flat
              fab
              small
              icon
              @click="$emit('input')"
              slot="activator"
            >
              <v-icon>close</v-icon>
            </v-btn>
            <span>Cancelar</span>
          </v-tooltip>
          <v-tooltip bottom>
            <v-btn
              color="primary"
              fab
              dark
              small
              @click="adiciona"
              :loading="loading"
              slot="activator"
            >
              <v-icon>done</v-icon>
            </v-btn>
            <span>Salvar</span>
          </v-tooltip>
        </v-card-title>

        <v-card-text>
          <v-menu v-model="atividadeDatepicker" :close-on-content-click="false" full-width>
            <v-text-field slot="activator" readonly
              :value="moment(dataPrevisao).format('DD/MM/YYYY')" label="Setar Previsão" prepend-icon="event">
            </v-text-field>
            <v-date-picker locale="pt" v-model="dataPrevisao" @change="atividadeDatepicker = false"></v-date-picker>
          </v-menu>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: ['value', 'atividade', 'loading'],
  data() {
    return {
      atividadeDatepicker: false,
      dataPrevisao: new Date().toISOString().substr(0, 10)
    }
  },
  methods: {
    adiciona() {
      if (this.dataPrevisao) {
        // this.dataPrevisao = this.moment.utc(this.dataPrevisao.toString()).toISOString();
        const [ano, mes, dia] = this.dataPrevisao.split('-');
        this.dataPrevisao = new Date(ano, mes - 1, dia);
        if (this.atividade !== null) {
          this.atividade.DataPrevisao = this.dataPrevisao;
          this.$emit('setaPrevisao', this.atividade);
          this.dataPrevisao = new Date().toISOString().substr(0, 10);
        } else {
          this.$emit('setaPrevisaoSelected', this.dataPrevisao);
          this.dataPrevisao = new Date().toISOString().substr(0, 10);
        }
      }
    }
  }
}
</script>

<style>

</style>
